import { exists, t } from "i18next";

export const trans = (key) => exists(key) ? t(key) : key;